import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="border-t border-gray-100 mt-auto">
            <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-center gap-4 text-xs text-gray-400">
                <Link to="/privacy" className="hover:text-gray-600 transition-colors">Privacy</Link>
                <span>·</span>
                <Link to="/terms" className="hover:text-gray-600 transition-colors">Terms</Link>
                <span>·</span>
                <Link to="/support" className="hover:text-gray-600 transition-colors">Support</Link>
            </div>
        </footer>
    );
}
